import { z } from 'my-zod'
import { enumOptionsToObject } from './enum-helpers'
import { ProductLine } from './product-lines'

export const SuperProductLineEnum = z.enum(['SXS', 'IND', 'SLG', 'ATV', 'ACE', 'PON', 'SNO'])
export type SuperProductLine = z.infer<typeof SuperProductLineEnum>

export const SuperProductLineOptions = Object.values(SuperProductLineEnum.Values)
export const SuperProductLines = enumOptionsToObject(SuperProductLineOptions)

export const SuperProductLinesNames = {
  SXS: 'Side-by-Side',
  ACE: 'ACE',
  ATV: 'ATV',
  IND: 'Indian',
  PON: 'Boat',
  SLG: 'Slingshot',
  SNO: 'Snowmobile'
}

export function getSuperProductLine(productLine: ProductLine): SuperProductLine {
  if (productLine === 'SNO') {
    return 'SNO'
  } else if (productLine === 'PON') {
    return 'PON'
  } else if (productLine === 'ATV') {
    return 'ATV'
  } else if (productLine === 'ACE') {
    return 'ACE'
  } else if (productLine === 'SLG') {
    return 'SLG'
  } else if (productLine === 'IND') {
    return 'IND'
  } else if (productLine === 'RZR' || productLine === 'RGR' || productLine === 'GEN') {
    return 'SXS'
  } else {
    throw new Error(`Unrecognized product line: ${productLine}`)
  }
}
